const LinkedInLogin = () => import(/* webpackChunkName: "auth" */ '@/modules/auth/views/LinkedInLogin')
import Auth from '@/services/Auth'
export default [
  {
    path: '/account/Login',
    name: 'LinkedInLogin',
    component: LinkedInLogin,
    beforeEnter: Auth.isGuest
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "auth" */ './views/Register.vue'),
    beforeEnter: Auth.isGuest
  },
  {
    path: '/sign-in',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ './views/LoginFormv2.vue'),
    beforeEnter: Auth.isGuest
  },
  {
    path: '/u/sign-in',
    name: 'LoginSelection',
    component: () => import(/* webpackChunkName: "auth" */ './views/LoginSelection.vue'),
    beforeEnter: Auth.isGuest
  },
  {
    path: '/u/register',
    name: 'SignupSelection',
    component: () => import(/* webpackChunkName: "auth" */ './views/SignupSelection.vue'),
    beforeEnter: Auth.isGuest
  },
  {
    path: '/email-verification',
    name: 'EmailVerification',
    component: () => import(/* webpackChunkName: "auth" */ './views/EmailVerification.vue'),
    beforeEnter: Auth.isUserLoggedIn
  },
  {
    path: '/account-in-review',
    name: 'AccountReview',
    component: () => import(/* webpackChunkName: "auth" */ './views/AccountReview.vue'),
    beforeEnter: Auth.isUserLoggedIn
  },
  {
    path: '/profile-verified',
    name: 'ProfileVerified',
    component: () => import(/* webpackChunkName: "auth" */ './views/ProfileVerified.vue'),
    beforeEnter: Auth.isUserLoggedIn
  },
  {
    path: '/verify-email/:userToken/:mailToken',
    name: 'VerifyEmail',
    component: () => import(/* webpackChunkName: "auth" */ './views/VerifyEmail.vue')
  }
]
